import { Component, Input, OnInit, inject } from '@angular/core';
import { appReducer, loadingSelectors, profileSelectors } from '@app-root-store';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    standalone: false
})
export class LoadingComponent implements OnInit {
    private store$ = inject<Store<appReducer.AppState>>(Store);

    @Input() loading: Observable<boolean>;
    @Input() centered = false;
    @Input() firstLoad = false;

    public noOpacity = false;

    private globalLoading$ = this.store$.pipe(select(loadingSelectors.currentlyLoading));
    public themeIsSet$: Observable<boolean> = this.store$.pipe(select(profileSelectors.selectProfileThemeIsSet));

    public isLoading$: Observable<boolean>;

    ngOnInit() {
        this.isLoading$ = this.loading || this.globalLoading$;
        this.noOpacity = this.firstLoad;

        this.themeIsSet$
            .pipe(
                filter((isSet) => !!isSet),
                take(1)
            )
            .subscribe(() => setTimeout(() => (this.noOpacity = false)));
    }
}
